<script>
    import CRUD from './CRUD.svelte';
    import ChangePasswordModal from '../components/ChangePasswordModal.svelte';
    import { 
        fetchUsers, 
        saveUser, 
        removeUser, 
        searchUsers, 
        subscribeToUsers, 
        unsubscribeFromUsers 
    } from '../controllers/userController.js';
    import { getRolesForDropdown } from '../controllers/roleController.js'; // Función para cargar roles
    import { onMount } from 'svelte';
    import { t } from 'svelte-i18n';

    let userColumns = [
        { label: 'Email', field: 'email', type: 'text' },
        { label: $t('fields.name'), field: 'name', type: 'text' },
        { label: 'Rol', field: 'role', type: 'relation', relationField: 'descrip' },
        { label: 'Verificado', field: 'verified', type: 'bool' },
        { label: 'Avatar', field: 'avatar', type: 'image' },
    ];

    let newUser = {
        id: '',
        email: '',
        emailVisibility: true,
        verified: false,
        name: '',
        avatar: '',
        role: '',
        password: '', // Required for new users
        passwordConfirm: '', // Required for new users
    };

    let editColumns = [
        { label: 'Email', key: 'email', type: 'email', required: true },
        { label: $t('fields.name'), key: 'name', type: 'text', required: true },
        { label: 'Rol', key: 'role', type: 'select', required: true, options: [] },
        { label: 'Contraseña', key: 'password', type: 'password', required: true, showOnCreate: true },
        { label: 'Confirmar Contraseña', key: 'passwordConfirm', type: 'password', required: true, showOnCreate: true },
        { label: 'Verificado', key: 'verified', type: 'checkbox' },
        { label: 'Avatar', key: 'avatar', type: 'file' },
    ];



    let showPasswordModal = false;
    let selectedUserId = '';

    function handlePasswordChange(userId) {
        selectedUserId = userId;
        showPasswordModal = true;
    }

    function handleClosePasswordModal() {
        showPasswordModal = false;
        selectedUserId = '';
    }

    // Add action buttons to the CRUD component
    let actionButtons = [
        {
            label: 'Cambiar Contraseña',
            icon: '🔑',
            onClick: handlePasswordChange
        }
    ];

    onMount(async () => {
        console.log("Componente de Usuarios montado");
        // Cargar roles para el dropdown
        try {
            const rolesOptions = await getRolesForDropdown();
            editColumns = editColumns.map(col => {
                if (col.key === 'role') {
                    return { ...col, options: rolesOptions };
                }
                return col;
            });
        } catch (error) {
            console.error("Error loading roles:", error);
        }
    });
</script>

<CRUD 
    title={$t('entities.usuarios')}
    entityName="users"
    newEntity={newUser}
    columns={userColumns}
    fetchEntities={fetchUsers}
    saveEntity={saveUser}
    removeEntity={removeUser}
    searchEntities={searchUsers}
    subscribeToChanges={subscribeToUsers}
    unsubscribeFromChanges={unsubscribeFromUsers}
    editColumns={editColumns}
    onPasswordChange={handlePasswordChange}
/>

<ChangePasswordModal 
    show={showPasswordModal}
    userId={selectedUserId}
    on:close={handleClosePasswordModal}
/>